// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-form-field[data-v-6e64d6e7]{box-sizing:border-box;width:100%}.fr-form-field>div[data-v-6e64d6e7]{margin-bottom:10px}.half-width[data-v-6e64d6e7]{width:50%;padding-right:5px}.half-width+.half-width[data-v-6e64d6e7]{padding-left:5px;padding-right:0}", ""]);
// Exports
module.exports = exports;
